/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Status of the transaction.
 */
export const TransactionStatus = {
  Pending: "pending",
  Paid: "paid",
  Refunded: "refunded",
  PartialRefund: "partialRefund",
  ChargedBack: "chargedBack",
  Uncollectible: "uncollectible",
  Declined: "declined",
  Void: "void",
} as const;
/**
 * Status of the transaction.
 */
export type TransactionStatus = ClosedEnum<typeof TransactionStatus>;

/** @internal */
export const TransactionStatus$inboundSchema: z.ZodNativeEnum<
  typeof TransactionStatus
> = z.nativeEnum(TransactionStatus);
/** @internal */
export const TransactionStatus$outboundSchema: z.ZodNativeEnum<
  typeof TransactionStatus
> = TransactionStatus$inboundSchema;
